import axios from 'axios'
import { EVENT_PLACE, EVENT_PLACE_LOCATIONS, USER_TOKEN } from "./CONSTANTS";

export const getEventPlaces = () => {
  console.info("EventPlaceServices > getEventPlaces...");
  return new Promise((resolve, reject) => {
      axios
      .get(EVENT_PLACE(),{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const getEventPlace = (uniqueKey) => {
  console.info("EventPlaceServices > getEventPlace...");
  return new Promise((resolve, reject) => {
      axios
      .get(EVENT_PLACE()+"/"+uniqueKey,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};
export const getEventPlaceLocations = (uniqueKey) => {
  console.info("EventPlaceServices > getEventPlaceLocations...");
  return new Promise((resolve, reject) => {
      axios
      .get(EVENT_PLACE_LOCATIONS()+"?id="+uniqueKey,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};
export const addEventPlace = (model) => {
  console.info("EventPlaceServices > addEventPlace...");
  return new Promise((resolve, reject) => {
      axios
      .post(EVENT_PLACE(), model,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const updateEventPlace = (model) => {
  console.info("updateSupplierServices > updateEventPlace...");
  return new Promise((resolve, reject) => {
      axios
      .put(EVENT_PLACE(), model,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const deleteEventPlace = (uniqueKey) => {
  console.info("EventPlaceServices > deleteEventPlace...");
  return new Promise((resolve, reject) => {
      axios
      .delete(EVENT_PLACE()+'/'+uniqueKey,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};